import { styled } from '@components-shared/src/stitches';
import { StyledScroll } from '@components/main-components/containers/RadixScroll';

export const MAX_UNVIRTUALIZED_ITEMS = 10;

export const StyledScrollArea = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  maxHeight: '396px',
  overflow: 'auto',
  height: '396px',
  ...StyledScroll,

  variants: {
    empty: {
      true: {
        overflow: 'hidden',
      },
    },
  },
});

export const FOLLOWERS_EMPTY_HEADER = 'Looking for followers?';
export const FOLLOWERS_EMPTY_SUBTEXT = (name: string) =>
  `When someone follows ${name}, they'll show up here`;

export const FOLLOWING_EMPTY_HEADER = (name: string) => `${name} isn't following anyone`;
export const FOLLOWING_EMPTY_SUBTEXT = (name: string) =>
  `When ${name} follows someone, they’ll show up here.`;
